import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { useCompleteVisit } from "src/hooks/useCompleteVisit";
import WhiteCard from "src/shared/components/WhiteCard";

const CompleteRefillVisit = () => {
  const { t } = useTranslation();
  const page = "completeRefill";
  const { handleGoToMessages, handleGoToPortal } = useCompleteVisit();

  return (
    <Stack gap={5}>
      <Stack gap={2}>
        <WhiteCard gap={1}>
          <Typography variant="body2">{t(`${page}.cards.0.title`)}</Typography>
          <Typography fontWeight={600}>
            {t(`${page}.cards.0.description`)}
          </Typography>
        </WhiteCard>
        <WhiteCard gap={1}>
          <Typography variant="body2" color="#3BB273">
            {t(`${page}.cards.1.title`)}
          </Typography>
          <Typography fontWeight={600}>
            {t(`${page}.cards.1.description`)}
          </Typography>
        </WhiteCard>
      </Stack>
      <Stack gap="16px">
        <Button onClick={handleGoToPortal}>
          {t(`${page}.buttons.0.label`)}
        </Button>
        <Button variant="secondary" onClick={handleGoToMessages}>
          {t(`${page}.buttons.1.label`)}
        </Button>
      </Stack>
    </Stack>
  );
};

export default CompleteRefillVisit;
